/* ============================================================
   BIBLIOTHÈQUE DE PARFUM — 7 РОКІВ · спільна логіка сторінки
   Файл: assets/bdp-anniversary.js
   ============================================================ */
(function () {
  'use strict';
  if (window.__bdpAnniversaryInit) return;
  window.__bdpAnniversaryInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function push(event, extra) {
    window.dataLayer = window.dataLayer || [];
    var data = { event: event };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) data[k] = extra[k];
    window.dataLayer.push(data);
  }

  /* ==========================================================
     02 · ПОЛИЦЯ РОЗДІЛІВ
     ========================================================== */
  var books = document.getElementById('bdp-books');
  var panelRO = null;

  function syncShelfHeight() {
    if (!books) return;
    var open = books.querySelector('.bdp-book.is-open');
    if (window.innerWidth < 990 || !open) { books.style.removeProperty('--rowH'); return; }
    var inner = open.querySelector('.bdp-panel__in');
    if (!inner) return;
    books.style.setProperty('--rowH', Math.max(620, Math.ceil(inner.getBoundingClientRect().height) + 16) + 'px');
  }

  function watchPanel() {
    if (panelRO) panelRO.disconnect();
    if (!books || !('ResizeObserver' in window)) return;
    var inner = books.querySelector('.bdp-book.is-open .bdp-panel__in');
    if (!inner) return;
    panelRO = new ResizeObserver(syncShelfHeight);
    panelRO.observe(inner);
  }

  /* opts.silent — тихе відкриття під час завантаження сторінки:
     не чіпаємо адресний рядок і не скролимо. Сторінка має відкриватися
     з першого екрана, а не стрибати до розділу. */
  function openChapter(book, opts) {
    opts = opts || {};
    if (!book || !books || book.dataset.status === 'future') return;
    [].forEach.call(books.children, function (b) {
      var on = b === book;
      b.classList.toggle('is-open', on);
      var btn = b.querySelector('.bdp-spine');
      if (btn) btn.setAttribute('aria-expanded', String(on));
      if (!on) { var v = b.querySelector('video'); if (v) v.pause(); }
    });
    push('anniversary_chapter_open', { chapter_id: book.dataset.chapter, chapter_status: book.dataset.status });
    syncShelfHeight(); watchPanel();

    if (opts.silent) return;

    if (opts.hash !== false) history.replaceState(null, '', '#chapter-' + book.dataset.chapter);
    if (opts.scroll) {
      var lib = document.getElementById('bdp-chapters');
      if (lib) lib.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    } else if (window.innerWidth < 990) {
      setTimeout(function () { book.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' }); }, 60);
    }
  }

  /* Хук для кнопки на обкладинці (секція 01).
     bdpOpenCurrentChapter(scroll, silent) */
  window.bdpOpenCurrentChapter = function (scroll, silent) {
    if (!books) {
      var t = document.getElementById('bdp-chapters');
      if (t && scroll) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      return;
    }
    var cur = books.querySelector('.bdp-book[data-status="current"]');
    if (!cur) {
      var past = books.querySelectorAll('.bdp-book[data-status="past"]');
      cur = past.length ? past[past.length - 1] : null;
    }
    if (cur) openChapter(cur, { scroll: !!scroll, silent: !!silent });
  };

  if (books) {
    [].forEach.call(books.querySelectorAll('.bdp-book'), function (book) {
      var btn = book.querySelector('.bdp-spine');
      if (!btn || book.dataset.status === 'future') return;
      btn.addEventListener('click', function () {
        if (window.innerWidth < 990 && book.classList.contains('is-open')) {
          book.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          return;
        }
        openChapter(book);
        requestAnimationFrame(syncShelfHeight);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var list = [].slice.call(books.querySelectorAll('.bdp-spine:not([disabled])'));
        var next = list[list.indexOf(btn) + (e.key === 'ArrowRight' ? 1 : -1)];
        if (next) { e.preventDefault(); next.focus(); }
      });
    });

    [].forEach.call(books.querySelectorAll('[data-drawer]'), function (d) {
      d.addEventListener('toggle', function () {
        syncShelfHeight();
        if (d.open) {
          var book = d.closest('.bdp-book');
          push('anniversary_' + (d.dataset.drawer === 'how' ? 'participation' : 'rules') + '_open',
            { chapter_id: book ? book.dataset.chapter : '' });
        }
      });
    });

    window.addEventListener('resize', syncShelfHeight);
    window.addEventListener('load', syncShelfHeight);

    /* Стартове відкриття — завжди тихе: сторінка лишається на першому екрані.
       Якщо в адресі є #chapter-NN, до розділу скролить сам браузер. */
    var m = location.hash.match(/^#chapter-(\d{2})$/);
    var target = m && books.querySelector('#chapter-' + m[1]);
    if (target && target.dataset.status !== 'future') openChapter(target, { silent: true });
    else window.bdpOpenCurrentChapter(false, true);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-scent]');
    if (!a) return;
    var book = a.closest('.bdp-book');
    push('anniversary_scent_click', { scent: a.dataset.scent, chapter_id: book ? book.dataset.chapter : '' });
  });

  /* ---------- Повноекранне відео ---------- */
  function toggleFullscreen(frame) {
    if (!frame) return;
    if (document.fullscreenElement) { if (document.exitFullscreen) document.exitFullscreen(); return; }
    var req = frame.requestFullscreen || frame.webkitRequestFullscreen;
    var video = frame.querySelector('video');
    if (req) {
      req.call(frame).then(function () {
        try { if (screen.orientation && screen.orientation.lock) screen.orientation.lock('landscape'); } catch (_) {}
      }).catch(function () { if (video && video.webkitEnterFullscreen) video.webkitEnterFullscreen(); });
    } else if (video && video.webkitEnterFullscreen) video.webkitEnterFullscreen();
    push('anniversary_video_fullscreen');
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fs]');
    if (!b) return;
    e.preventDefault();
    toggleFullscreen(b.closest('[data-film]'));
  });

  /* ---------- Обкладинка відео: кнопка відтворення ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-play]');
    if (!b) return;
    e.preventDefault();
    var frame = b.closest('[data-film]');
    var v = frame && frame.querySelector('video');
    if (!v) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    push('anniversary_video_play', { chapter_id: (frame.closest('.bdp-book') || {}).dataset ? frame.closest('.bdp-book').dataset.chapter : '' });
  });

  /* Ролик запустили — прибираємо обкладинку й показуємо рідні контроли */
  document.addEventListener('play', function (e) {
    if (!e.target || e.target.tagName !== 'VIDEO') return;
    var frame = e.target.closest('[data-film]');
    if (frame) frame.classList.add('is-playing');
  }, true);

  document.addEventListener('fullscreenchange', function () {
    var on = !!document.fullscreenElement;
    [].forEach.call(document.querySelectorAll('[data-fs]'), function (b) {
      var span = b.querySelector('span');
      if (span) span.textContent = on ? (b.dataset.labelExit || 'Згорнути') : (b.dataset.label || 'На весь екран');
    });
    if (!on) { try { if (screen.orientation && screen.orientation.unlock) screen.orientation.unlock(); } catch (_) {} }
  });

  var mmLandscape = window.matchMedia('(orientation: landscape)');
  if (mmLandscape.addEventListener) {
    mmLandscape.addEventListener('change', function (e) {
      if (!e.matches || window.innerWidth >= 990 || document.fullscreenElement) return;
      var v = document.querySelector('.bdp-book.is-open video');
      if (v && !v.paused) toggleFullscreen(v.closest('[data-film]'));
    });
  }

  /* ==========================================================
     Каруселі: стрілки + таби
     ========================================================== */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-scroll]');
    if (!b) return;
    var el = document.getElementById(b.dataset.scroll);
    if (el) el.scrollBy({ left: (+b.dataset.dir) * Math.min(el.clientWidth * 0.8, 640), behavior: reduce ? 'auto' : 'smooth' });
  });

  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('.bdp-tab');
    if (!tab) return;
    var tablist = tab.closest('[role="tablist"]');
    if (!tablist) return;
    var ids = [].map.call(tablist.querySelectorAll('.bdp-tab'), function (x) { return x.getAttribute('aria-controls'); });
    [].forEach.call(tablist.querySelectorAll('.bdp-tab'), function (x) {
      var on = x === tab;
      x.setAttribute('aria-selected', String(on));
      var panel = document.getElementById(x.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
    var scope = tablist.closest('.shopify-section') || document;
    [].forEach.call(scope.querySelectorAll('[data-scroll]'), function (btn) {
      if (ids.indexOf(btn.dataset.scroll) > -1) btn.dataset.scroll = tab.getAttribute('aria-controls');
    });
  });

  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('a[data-card]');
    if (c) push('anniversary_product_click', { sku: c.dataset.card });
  });

  /* ==========================================================
     07 · СІМ БАЖАНЬ + FAQ
     ========================================================== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.bdp-wsp__face');
    if (!btn || btn.tagName !== 'BUTTON') return;
    var sp = btn.closest('.bdp-wsp');
    if (!sp || sp.dataset.w === 'locked') return;
    var on = !sp.classList.contains('is-open');
    sp.classList.toggle('is-open', on);
    btn.setAttribute('aria-expanded', String(on));
    if (on) {
      var n = sp.querySelector('.bdp-wsp__n');
      push('anniversary_wish_open', { wish: n ? n.textContent : '' });
    }
  });

  [].forEach.call(document.querySelectorAll('.bdp-faq'), function (faq) {
    faq.addEventListener('toggle', function (e) {
      if (!e.target.open || window.innerWidth < 990) return;
      [].forEach.call(faq.querySelectorAll('details[open]'), function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });

  /* ---------- Плавна поява секцій ---------- */
  var reveals = document.querySelectorAll('.bdp-reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    [].forEach.call(reveals, function (el) { io.observe(el); });
  } else {
    [].forEach.call(reveals, function (el) { el.classList.add('is-in'); });
  }
})();
/* КІНЕЦЬ ФАЙЛУ */
